var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium",
    transform: "translate(-1031, -4679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1031, 4679)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F3F3F3",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-location-7015294",
    transform: "translate(11, 8)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,17 C7.28319544,16.2754 13,11 13,6.2245 C13,2.79975 10.102699,0 6.5,0 C2.89730099,0 0,2.79975 0,6.2245 C0,11 5.71680456,16.27525 6.5,17 Z M3.44579886,6.3495 C3.44579886,4.7245 4.82965298,3.42475 6.5,3.42475 C8.19692345,3.42475 9.55420114,4.74995 9.55420114,6.3495 C9.55420114,7.9745 8.17034702,9.27425054 6.5,9.27425054 C4.80307655,9.2752265 3.44579886,7.950025 3.44579886,6.3495 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconGrey);
export default __webpack_public_path__ + "static/media/location-icon--grey.5b4d10bbe9fbea9fde1b4f6e911ed063.svg";
export { ForwardRef as ReactComponent };